import { ValidationReasons } from "../types/ValidationReasons.js";
const getValidationReason = (params) => {
  const reasons = [];
  return params.city || reasons.push(ValidationReasons.City), params.streetAddress || reasons.push(ValidationReasons.StreetAddress), "streetNumber" in params && !params.streetNumber && reasons.push(ValidationReasons.StreetNumber), "route" in params && !params.route && reasons.push(ValidationReasons.Route), params.state || reasons.push(ValidationReasons.State), params.postalCode || reasons.push(ValidationReasons.PostalCode), params.country !== "US" && reasons.push(ValidationReasons.Country), reasons;
};
export {
  getValidationReason
};
//# sourceMappingURL=getValidationReason.js.map
